import type { ShiritoriGameStore } from '@/game/core/game.store';
import { LocalStorageKeyName, RemoveLocalStorage } from '@/util/local-storage';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from './home/buttons';
import { Card } from './home/card';

interface LeaveGameDialogProps {
    game: ShiritoriGameStore;
}

export function LeaveGameDialog({ game }: LeaveGameDialogProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);

    /**
     * This was hacky as heck but I had put the header one level higher than the game itself.
     * Didn't want to hoist the state and do some rewrites, so portal it is
     */
    const headerActions = document.getElementById('header-game-actions');

    function onLeaveGame() {
        setIsOpen(false);

        game.leaveGame().catch((error) => {
            console.error('[leaveGame]', error);
        });

        RemoveLocalStorage(LocalStorageKeyName.GameId);
        navigate('/', { replace: true });
    }

    return (
        <>
            {headerActions && createPortal(
                <button type="button" onClick={() => setIsOpen(true)} className="px-3 py-2 hover:text-foreground cursor-pointer">
                    {t('header.txtLeave')}
                </button>,
                headerActions,
            )}

            {isOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/25 backdrop-blur-sm px-4">
                    <Card header={t('dialog.leave.txtTitle')} role="dialog" aria-modal="true" aria-label={t('dialog.leave.txtTitle')} className="w-full max-w-md shadow-2xl">
                        <div className="flex flex-col space-y-3">
                            <Button type="button" hotkey={{ key: 'Escape', display: 'Esc', allowInInput: true }} onClick={() => setIsOpen(false)}>
                                {t('dialog.leave.btnStay')}
                            </Button>
                            <Button type="button" variant="danger" hotkey={{ key: 'Enter', display: '⏎', allowInInput: true }} onClick={onLeaveGame}>
                                {t('dialog.leave.btnLeave')}
                            </Button>
                        </div>
                    </Card>
                </div>
            )}
        </>
    );
}
